import { AppBar, Autocomplete, FormControl, ListItemText, TextField, Toolbar, Tooltip } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { SyntheticEvent} from 'react'
import { ColoredIconButton } from '../common/ColoredIconButton'
import { useSelector } from '../../redux/hooks/useSelector'
import { useTranslation } from 'react-i18next'
import { newThemeObject } from '../../newTheme'
import DownloadIcon from '@mui/icons-material/Download';
import { Client } from '../../redux/reducers/clients'

const useStyles = makeStyles(theme => ({
  tableTopBar: {
    backgroundColor: newThemeObject.palette.orderTable.searchBar.bg,
    borderRadius: newThemeObject.roundness.basic,
    marginBottom: theme.spacing(2),
  },
  tableToolBar: {
    minHeight: 0,
    display: 'flex',
    gap: theme.spacing(1),
    width: '100%',
    padding: theme.spacing(2),
    margin: 0,
    flexDirection: 'column',
    paddingLeft: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  separator: {
    flexGrow: 1,
  },
  textField: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 400,
    },
    marginRight: theme.spacing(1),
  },
  icon: {
    color: newThemeObject.palette.main.sectext,
    backgroundColor: '#ffffff',
  },
}))

interface ClientTableTopBarProps {
  setSelectedClient: (client: Client | null) => any
}

export const ClientDetailTopBar = ({
  setSelectedClient,
}: ClientTableTopBarProps) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const clients = useSelector(state => state.clients.clients)
  console.log('clients', clients);

  return (
    <AppBar position="static" className={classes.tableTopBar} elevation={0}>
      <Toolbar variant="dense" className={classes.tableToolBar}>

        <FormControl className={classes.textField}>
          <Autocomplete
            id="clientFilter"
            options={clients}
            filterSelectedOptions
            getOptionLabel={(option: Client) => option.firstName+' '+option.surname}
            onChange={(event: SyntheticEvent<Element, Event>, value: Client | null)=>{
              setSelectedClient(value);
            }}
            renderInput={params => (
              <TextField
                {...params}
                variant="standard"
                placeholder={t('CLIENT')}
              />
            )}
            renderOption={(props, item) => (
              <li {...props} key={item.clientId}>
                <ListItemText>{item.firstName+' '+item.surname}</ListItemText>
              </li>
            )}
          />
        </FormControl>

        <span className={classes.separator} />


        <Tooltip title={t('EXPORT_IN_PROGRES')}><div>
          <ColoredIconButton
            disabled
            className={classes.icon}
            onClick={() => {console.log('')}}
            size="small"
            icon={<DownloadIcon />}
          /></div>
        </Tooltip>

      </Toolbar>
    </AppBar>
  )
}
